import { useMutation } from '@tanstack/react-query';
import { useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';

import { useUserData } from 'user/hooks/useUserData';
import { useModalStore } from 'common/hooks/useModals';
import { invalidateAccountAircraft } from 'aircraft/hooks/useAccountAircraft';
import { invalidateAllSystemAircraft } from 'aircraft/hooks/useAllSystemAircraft';
import ApiError from 'errors/ApiError';

export const initiateTailnumberChangeBgJob = async ({
  token, reg_n_number, new_reg_n_number, company_id,
}) => fetch(`${process.env.REACT_APP_BASEURL}/admin/initiateTailnumberChangeBgJob`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: token,
  },
  body: JSON.stringify({
    reg_n_number,
    new_reg_n_number,
    company_id,
  }),
}).then(async (res) => {
  const data = await res.json();

  if (!res.ok) {
    throw new ApiError(res, data);
  }

  return {
    response: res,
    responseData: data,
  };
});

const useChangeRegistration = () => {
  const {
    setChangeRegistrationState,
  } = useModalStore();

  const {
    userData,
  } = useUserData();

  const {
    token,
  } = userData;

  const mutation = useMutation({
    mutationFn: initiateTailnumberChangeBgJob,
    // eslint-disable-next-line no-unused-vars
    onError: (error, variables, context) => {
      if (error instanceof ApiError) {
        const { responseData } = error;

        toast.error(responseData.message);
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSuccess: async (data, variables, context) => {
      // The rename runs as a background job, so the new tail number only shows up on a later
      // refetch. Invalidate both aircraft lists that can host this action.
      invalidateAccountAircraft();
      invalidateAllSystemAircraft();

      toast.success(data.responseData.message);
      setChangeRegistrationState(false);
    },
  });

  const doMutation = useCallback((params = {}, options = {}) => mutation.mutate({
    token, ...params,
  }, options), [mutation, token]);

  return useMemo(() => ({
    mutation: doMutation,
  }), [doMutation]);
};

export { useChangeRegistration };
